import { render } from "./QuestionOne.vue?vue&type=template&id=172a9864&scoped=true"
const script = {}

import "./QuestionOne.vue?vue&type=style&index=0&id=172a9864&scoped=true&lang=scss"

import exportComponent from "/Users/silaskoehler/sublimes/bibelzentrum-herz-pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172a9864"]])

export default __exports__